<template>
  <div class="disponibilita">
    <div class="list-codicearticolo padding-title">
      <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
        <p class="">{{ disponibilità_text }}</p>
      </div>
   <!--   <p class="disponibilità_top_text mbt-0 pbt-0">
        {{ disponibilità_top_text }}: {{ availability }}
      </p> -->
       <p class="disponibilità_top_text mbt-0 pbt-0">
        {{ disponibilità_to }}: <strong> {{ availability_from }} </strong>
      </p>
    </div>

    <div class="list-codicearticolo padding-title">
      <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo"></div>
      <div class="list-disponibilita padding-title"></div>
    </div>
  </div>
</template>
<script>
import checkLanguage from "../classes/class_check_language";

export default {
  name: "disponibilita",
  data: () => ({

    availability:'', 
    availability_from : '',
  }),

   mounted() {
  this.$store.subscribe((mutation) => {
             if (mutation.type == 'select_product_by_id'){
                    this.availability =  this.$store.state.product_store.DISPONIBILITA ;
                    this.availability_from =  this.$store.state.product_store.DATA_DISPONIBILE ;
          }
  });


  },
  computed: {
    disponibilità_text() {
      let i = new checkLanguage();
      if (i.is_italian()) {
        let language = this.$store.state.product.language;
        return this.$store.state[language].disponibilita;
      } else {
        return "AVAILABILITY";
      }
    },
    quantità_text() {
      return this.$store.state.quantita;
    },
    disponibilità_top_text() {
      let i = new checkLanguage();
      if (i.is_italian()) {
      let language = this.$store.state.product.language;
      return this.$store.state[language].disponibilità_top_text;
      } else {
        return "Availability";
      }
    },
    disponibilità_to() {
      let i = new checkLanguage();
      if (i.is_italian()) {
        let language = this.$store.state.product.language;
        return this.$store.state[language].disponibilita_al;
      } else {
        return "Availability from";
      }
    },
 //   quantita() {
 //     return this.$store.state.product.quantita;
 //   },
  },
};
</script>
<style scoped>
.mbt-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.pbt-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>